import { useEffect, useMemo } from 'react';
import { Button, Typography, Row, Col } from 'antd';
import { UserOutlined, PhoneOutlined, MailOutlined, CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';


const { Text } = Typography;

const PersonalInformationView = ({ userData, onEdit }) => {

    useEffect(() => {
    }, [])

    const displayData = userData;

  // Normalize to an array
  const preferredComm = useMemo(() => {
    const flags = [
      displayData?.preferEmail ? 'Email' : null,
      displayData?.preferPhone ? 'Phone' : null,
    ].filter(Boolean);

    const fromArray = Array.isArray(displayData?.preferredCommunication)
      ? displayData.preferredCommunication.filter(Boolean)
      : null;

    const fromString = typeof displayData?.preferredCommunication === 'string'
      ? displayData.preferredCommunication.split(',').map(s => s.trim()).filter(Boolean)
      : null;

    if (flags.length) return flags;
    if (fromArray?.length) return fromArray;
    if (fromString?.length) return fromString;
    return [];
  }, [displayData]);

  const preferredCommText = preferredComm.length ? preferredComm.join(', ') : 'N/A';

    return (
        <>

            <Row gutter={[24, 24]} >
                {/* Left Column: Profile Picture */}
                <Col xs={24} md={6} style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '120px', // Slightly larger for view
                        height: '120px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        border: '1px solid #d9d9d9',
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#fafafa',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
                    }}>
                        {displayData.profilePicture && displayData.profilePicture.base64 ? (
                            <img
                                // Construct the full Data URL using the type and base64 string
                                src={`data:${displayData.profilePicture.type};base64,${displayData.profilePicture.base64}`}
                                alt="profile"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            <UserOutlined style={{ fontSize: '60px', color: '#999' }} />
                        )}
                    </div>
                </Col>

                {/* Middle Column: Personal Details */}
                <Col xs={24} md={10}>
                    <Text strong style={{ display: 'block', marginBottom: '12px', fontSize: '18px' }}>
                        {displayData?.title?.value} {displayData.firstName} {displayData.lastName}
                    </Text>
                    <p>
                        <PhoneOutlined />  {displayData.contactNumber}
                    </p>
                    <p>
                        <MailOutlined /> {displayData.email}
                    </p>
                    <p>
                        <CalendarOutlined /> {" "}
                        {displayData.dateOfBirth ? dayjs(displayData.dateOfBirth).format("YYYY-MM-DD") : null}
                    </p>
                    <p>
                        <Text strong>Gender:</Text> {displayData?.gender?.value}
                    </p>
                    <p>
                        <Text strong>Race:</Text> {displayData?.race?.value}
                    </p>
                    <p>
                        <Text strong>Disability:</Text> {displayData?.disability?.value}
                    </p>
                    <p>
                        <Text strong>Languages:</Text>{" "}
                        {displayData?.languages && displayData?.languages?.map(lang => lang.value).join(', ')}
                    </p>

                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12 }}>
                            <Text strong>Preferred method of communication:</Text>
                            <Text>
                                {preferredCommText}
                            </Text>
                        </div>
                </Col>

                {/* Right Column: Address */}
                <Col xs={24} md={8}>
                    <Text strong style={{ display: 'block', marginBottom: '15px', fontSize: '18px' }}>Address</Text>
                    <p>
                        <Text strong>Province:</Text> {displayData?.location?.province?.value}
                    </p>
                    <p>
                        <Text strong>District:</Text> {displayData?.location?.district?.value}
                    </p>
                    <p>
                        <Text strong>Town/City:</Text> {displayData?.location?.town?.value}
                    </p>
                    <p>
                        <Text strong>Open to volunteer outside your location:</Text> {displayData?.volunteerDifferentLocation ? 'Yes' : 'No'}
                    </p>
                </Col>
            </Row>

            <div style={{ textAlign: 'right', marginTop: '30px' }}>
                <Button
                    type="primary"
                    onClick={onEdit}
                    // style={{ backgroundColor: '#fa541c', borderColor: '#fa541c' }}
                    className="primary-volunteer-button"
                >
                    Edit
                </Button>
            </div>
        </>
    );
};

export default PersonalInformationView;